import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {faTrailer} from '@fortawesome/free-solid-svg-icons';
import {TrailerService} from 'app/blocks/service/api/trailer.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL, SERVER_API_URL} from 'app/app.constants';
import {ITrailer, Trailer} from 'app/blocks/model/trailer.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';
import {AttemptedCollection} from 'app/blocks/model/attempted-collection-model';
import {HttpClient} from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class TrailerResource extends AbstractEntityResource<ITrailer> {
    constructor(trailerService: TrailerService, router: Router) {
        super(
            Resource.TRAILERS,
            trailerService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.TRAILERS, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.TRAILERS),
            (entity?) => new Trailer(entity),
            (entity) => entity.trailerRef,
            faTrailer
        );
    }
}
